<template>
    <div class="layout-dashboard">
        <div class="grid">
            <div class="col-12 md:col-12 xl:col-3" v-if="authStore.hasPermission(UserPermission.READ_TASK)">
                <div class="card overview-box blue">
                    <EntityBox title="Tasks" :total="taskStore.totalRecords" routeName="Tasks" />
                </div>
            </div>

            <div class="col-12 md:col-12 xl:col-3" v-if="authStore.hasPermission(UserPermission.READ_DEBRIEF)">
                <div class="card overview-box teal">
                    <EntityBox title="Debriefs" :total="debriefStore.totalRecords" routeName="Tasks" />
                </div>
            </div>

            <div class="col-12 md:col-12 xl:col-3">
                <div class="card overview-box orange">
                    <EntityBox title="Reports" :total="9" />
                </div>
            </div>

            <div class="col-12 md:col-12 xl:col-3" v-if="authStore.hasPermission(UserPermission.READ_USERS)">
                <div class="card overview-box pink">
                    <EntityBox title="Users" :total="userStore.totalUsers" />
                </div>
            </div>

            <div class="col-12 xl:col-12" v-if="authStore.hasPermission(UserPermission.READ_TASK)">
                <div class="card">
                    <div class="card-header">
                        <h4>Tasks Over Due Date:</h4>
                    </div>
                    <!-- latest tasks assigned to me table -->
                    <landing-tasks-table type="over-due-date" />
                </div>
            </div>
            <div class="col-12 xl:col-12" v-if="authStore.hasPermission(UserPermission.READ_TASK)">
                <div class="card">
                    <div class="card-header">
                        <h4>Tasks Near Due Date:</h4>
                    </div>
                    <!-- latest tasks assigned to me table -->
                    <landing-tasks-table type="near-due-date" />
                </div>
            </div>
            <div class="col-12 xl:col-12" v-if="authStore.hasPermission(UserPermission.READ_TASK)">
                <div class="card">
                    <div class="card-header">
                        <h4>Latest Tasks Assigned To Me:</h4>
                    </div>
                    <!-- latest tasks assigned to me table -->
                    <landing-tasks-table type="latest-tasks" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import EntityBox from '../components/EntityBox.vue';
import LandingTasksTable from '../components/LandingTasksTable.vue';
import { authStore, debriefStore, taskStore, userStore } from '../../../../../store/global-stores';
import { onBeforeMount, onMounted } from 'vue';
import { UserPermission } from '@/modules/permission/enum';
import { buildPagination } from '@/composables/PaginationComposable';

onBeforeMount( () => {
    buildPagination('landingTasks', 0, 10)
})

onMounted(() => {

    //READ_TASK
    if (authStore.hasPermission(UserPermission.READ_TASK)) {
        loadTasks();
    }
    if (authStore.hasPermission(UserPermission.READ_DEBRIEF)) {
        loadDebriefs();
    }
    if (authStore.hasPermission(UserPermission.READ_USERS)) {
        loadUsers();
    }
});

const loadTasks = async () => {
    await taskStore.getExistingTasks('landingTasks');
};

const loadDebriefs = async () => {
    await debriefStore.fetchAllDebriefs();
};

const loadUsers = async () => {
    await userStore.fetchAllUsers();
};
</script>
